/**
 * Zanniva — widget cash-on-delivery.
 * Vanilla, zéro dépendance, aucun appel réseau au chargement.
 * Le HTML des offres est rendu côté serveur (Liquid) : ce script ne fait que
 * câbler la sélection et la soumission. Il ne calcule ni n'envoie aucun prix.
 *
 * Chargement : <script src="..." defer></script>
 */
(function () {
  "use strict";

  // Overlay de diagnostic, active uniquement via ?coddebug=1. Mesure pure --
  // aucun changement fonctionnel, aucun reseau, aucun stockage. Objectif
  // unique : savoir avec certitude, sur un telephone reel (WebView
  // FacebookApp incluse), ce que l'API VisualViewport et le meta viewport
  // font reellement dans ce navigateur, avant d'y construire quoi que ce
  // soit dessus. Position en HAUT de l'ecran (jamais en bas) pour ne jamais
  // se retrouver elle-meme cachee par un clavier pendant la mesure.
  function initDebugOverlay() {
    var params = new URLSearchParams(window.location.search);
    if (params.get("coddebug") !== "1") return;

    var el = document.createElement("div");
    el.setAttribute(
      "style",
      "position:fixed;top:0;left:0;right:0;z-index:999999;" +
        "background:rgba(0,0,0,.88);color:#0f0;font:10px/1.35 ui-monospace,SFMono-Regular,Menlo,monospace;" +
        "padding:6px 8px;white-space:pre-wrap;pointer-events:none;max-height:48vh;overflow:hidden;"
    );
    document.body.appendChild(el);

    var vv = window.visualViewport;
    var resizeCount = 0;
    var scrollCount = 0;
    if (vv) {
      vv.addEventListener("resize", function () { resizeCount++; });
      vv.addEventListener("scroll", function () { scrollCount++; });
    }

    function rectOf(target) {
      if (!target) return "(aucun)";
      var r = target.getBoundingClientRect();
      return "top=" + Math.round(r.top) + "px bottom=" + Math.round(r.bottom) + "px";
    }

    function render() {
      var metas = document.querySelectorAll('meta[name="viewport"]');
      var lastMetaContent = metas.length ? metas[metas.length - 1].getAttribute("content") : "(aucune balise)";
      var active = document.activeElement;
      var isField = active && /^(INPUT|SELECT|TEXTAREA)$/.test(active.tagName);
      var submitBtn = document.querySelector("[data-zc-submit]");

      el.textContent =
        "[coddebug] mesure pure, aucun correctif applique\n" +
        "window.innerHeight              = " + window.innerHeight + "px\n" +
        "documentElement.clientHeight    = " + document.documentElement.clientHeight + "px\n" +
        "window.scrollY                  = " + Math.round(window.scrollY) + "px\n" +
        (vv
          ? "visualViewport.height           = " + vv.height + "px\n" +
            "visualViewport.offsetTop        = " + vv.offsetTop + "px\n" +
            "visualViewport.pageTop          = " + vv.pageTop + "px\n"
          : "visualViewport                  = API ABSENTE\n") +
        "vv resize events recus          = " + resizeCount + "\n" +
        "vv scroll events recus          = " + scrollCount + "\n" +
        "meta[name=viewport] trouvees    = " + metas.length + "\n" +
        "  -> contenu de la derniere : " + lastMetaContent + "\n" +
        "champ focalise (rect)           = " + (isField ? rectOf(active) : "(aucun champ focalise)") + "\n" +
        "bouton d'envoi (rect)           = " + rectOf(submitBtn);
    }

    // Rafraichi en continu, pas seulement sur evenement : si les valeurs
    // bougent a l'ouverture du clavier mais que les compteurs resize/scroll
    // restent a 0, ca prouve que l'API a les bonnes valeurs mais n'emet
    // jamais d'evenement sur ce navigateur -- distinction impossible a
    // faire avec un rendu uniquement pilote par evenements.
    setInterval(render, 200);
    render();
  }
  initDebugOverlay();

  // Zambie uniquement : préfixe +260 figé dans l'UI, la cliente ne saisit/colle
  // que les 9 chiffres nationaux (commençant par 9 ou 7). Même règle que
  // server/src/phone.ts (source de vérité serveur) -- gardée volontairement
  // dupliquée ici en JS pur (pas d'import cross-repo côté widget), donc toute
  // modification de la règle doit être répercutée dans les deux fichiers.
  //
  // Tolérant au collage : si la cliente colle un numéro complet
  // ("0971234567", "+260971234567", "260971234567", avec espaces/tirets...),
  // on en extrait silencieusement les 9 chiffres nationaux au lieu de rejeter.
  function extractNational(v) {
    var digits = String(v).trim().replace(/\D/g, "");
    if (digits.indexOf("00") === 0) digits = digits.slice(2);
    if (digits.length === 9) return digits;
    if (digits.length === 10 && digits.charAt(0) === "0") return digits.slice(1);
    if (digits.length === 12 && digits.indexOf("260") === 0) return digits.slice(3);
    return digits; // longueur/prefixe non reconnu -- laisse tel quel, la validation tranchera
  }

  function isValidNational(national) {
    return /^[79]\d{8}$/.test(national);
  }

  // Tâche 7 -- capture des signaux d'attribution Meta. Portée : ce script
  // n'est chargé que sur les pages où le widget COD est embarqué (pages
  // produit), pas un tag site-wide -- "toute page" se limite donc en
  // pratique aux pages produit, seules pages où ce fichier tourne.
  var ATTR_KEY = "zan_attr";
  var ATTR_TTL_MS = 90 * 24 * 3600 * 1000; // 90 jours
  var TEST_NAME_RE = /^(test|pixel test|phone fix)/i;

  function getCookie(name) {
    var re = new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)");
    var match = document.cookie.match(re);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // Persiste fbclid/utm_* dans localStorage, TTL 90 jours. Ne remplace
  // JAMAIS une valeur déjà stockée par une valeur vide -- un clic ultérieur
  // sans paramètres (navigation interne, etc.) ne doit pas effacer
  // l'attribution d'origine.
  function captureAttribution() {
    try {
      var params = new URLSearchParams(window.location.search);
      var now = Date.now();
      var stored = null;
      try {
        var raw = localStorage.getItem(ATTR_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && now - parsed.ts <= ATTR_TTL_MS) stored = parsed;
        }
      } catch (err) {}

      var merged = stored || {};
      ["fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (key) {
        var v = params.get(key);
        if (v) merged[key] = v;
      });
      merged.ts = now;
      localStorage.setItem(ATTR_KEY, JSON.stringify(merged));
    } catch (err) {
      console.error("[zc] attribution capture failed:", err);
    }
  }

  function readAttribution() {
    try {
      var raw = localStorage.getItem(ATTR_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.ts > ATTR_TTL_MS) return {};
      return parsed;
    } catch (err) {
      return {};
    }
  }

  // _fbc absent (bloqueur de cookies tiers, première visite très récente...)
  // mais fbclid connu -> reconstruction au format exact attendu par Meta.
  function buildFbc(fbclid) {
    var existing = getCookie("_fbc");
    if (existing) return existing;
    if (!fbclid) return null;
    return "fb.1." + Date.now() + "." + fbclid;
  }

  captureAttribution();

  function init(root) {
    if (root.dataset.zcReady) return;
    root.dataset.zcReady = "1";

    var openedAt = Date.now();
    var endpoint = root.dataset.endpoint;
    var productId = root.dataset.productId;
    var tiers = Array.prototype.slice.call(root.querySelectorAll("[data-offer]"));
    var form = root.querySelector("[data-zc-form]");
    // Garde defensive : le formulaire est genere par widgetHtml() et devrait
    // toujours etre present, mais si un futur variant de markup l'omet, mieux
    // vaut ne rien cabler plutot que planter sur tous les form.xxx qui suivent
    // (submit, validation, soumission).
    if (!form) return;
    var submit = root.querySelector("[data-zc-submit]");
    var errorBox = root.querySelector("[data-zc-error]");
    var selected = root.dataset.defaultOffer || (tiers[0] && tiers[0].dataset.offer);

    function select(id) {
      selected = id;
      tiers.forEach(function (el) {
        var on = el.dataset.offer === id;
        el.setAttribute("aria-checked", on ? "true" : "false");
        el.classList.toggle("is-selected", on);
        el.tabIndex = on ? 0 : -1;
      });
      // Tous les [data-zc-total] (récap, bouton, barre collante) reçoivent le
      // data-total de l'offre choisie ; relus à chaque appel car le libellé du
      // bouton est recréé après un envoi en erreur. "K990.00" -> "K990" :
      // affichage seulement, le prix vient toujours de data-total.
      var chosen = tiers.filter(function (el) {
        return el.dataset.offer === id;
      })[0];
      if (chosen && chosen.dataset.total) {
        var amount = chosen.dataset.total.replace(/\.00$/, "");
        Array.prototype.forEach.call(root.querySelectorAll("[data-zc-total]"), function (el) {
          el.textContent = amount;
        });
      }
    }

    tiers.forEach(function (el, i) {
      el.addEventListener("click", function () {
        select(el.dataset.offer);
      });
      el.addEventListener("keydown", function (e) {
        var next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = tiers[(i + 1) % tiers.length];
        if (e.key === "ArrowLeft" || e.key === "ArrowUp")
          next = tiers[(i - 1 + tiers.length) % tiers.length];
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          select(el.dataset.offer);
        }
        if (next) {
          e.preventDefault();
          select(next.dataset.offer);
          next.focus();
        }
      });
    });
select(selected);

    // Mode "modal" (ex. ClearDot) : le formulaire ne vit pas dans le flux de
    // page normal, il est caché dans un dialogue tant que le bouton autonome
    // n'a pas été cliqué. On câble l'ouverture/fermeture ici ; le reste
    // (validation, soumission, redirection) est strictement le même code que
    // le mode inline, aucune duplication.
    var modalTrigger = root.querySelector("[data-zc-modal-trigger]");
    var modal = root.querySelector("[data-zc-modal]");
    var isModal = !!(modalTrigger && modal);
    var openModal, closeModal;
    if (isModal) {
      var modalBackdrop = modal.querySelector("[data-zc-modal-backdrop]");
      var modalClose = modal.querySelector("[data-zc-modal-close]");
      var lastFocused = null;

      // Safari/iOS et les navigateurs in-app (ex. FacebookApp Android
      // WebView) ne redimensionnent pas le viewport de LAYOUT quand le
      // clavier s'ouvre (contrairement a Chrome/Android standalone) -- un
      // modal position:fixed cale sur ce viewport-la deborde alors sous le
      // clavier, et les derniers champs/le bouton d'envoi deviennent
      // invisibles/inatteignables, sans que le champ focalise ne soit
      // auto-scrolle. L'API VisualViewport donne la vraie zone visible ; on
      // y recale le modal (hauteur + decalage) a chaque resize/scroll,
      // throttle via requestAnimationFrame pour eviter les recalculs en
      // rafale pendant l'animation d'ouverture/fermeture du clavier.
      var vv = window.visualViewport;
      var syncQueued = false;
      function syncModalToViewport() {
        if (syncQueued) return;
        syncQueued = true;
        requestAnimationFrame(function () {
          syncQueued = false;
          if (!vv || !modal.classList.contains("is-open")) return;
          modal.style.setProperty("--cod-vvh", vv.height + "px");
          // Compense le decalage du viewport visuel par rapport au viewport
          // de layout (ex. la barre d'adresse qui se retracte, ou la zone
          // masquee par le clavier dans un navigateur in-app) : sans ce
          // translateY, le haut de la modale peut se retrouver hors-ecran.
          modal.style.transform = "translateY(" + vv.offsetTop + "px)";
        });
      }
      function attachViewportListeners() {
        if (!vv) return; // fallback : pas de VisualViewport -> CSS 100% par defaut, comportement inchange
        vv.addEventListener("resize", syncModalToViewport);
        vv.addEventListener("scroll", syncModalToViewport);
      }
      function detachViewportListeners() {
        if (!vv) return;
        vv.removeEventListener("resize", syncModalToViewport);
        vv.removeEventListener("scroll", syncModalToViewport);
      }
      // A chaque changement de champ focalise : le clavier peut changer de
      // hauteur (numerique pour le telephone vs texte pour le nom) sans
      // forcement redeclencher un resize VisualViewport assez tot, et le
      // champ nouvellement focalise n'est pas forcement dans la zone
      // visible restante. Le setTimeout de 300ms laisse l'animation
      // d'ouverture du clavier se terminer avant de mesurer/scroller.
      form.addEventListener("focusin", function (e) {
        var field = e.target;
        setTimeout(function () {
          syncModalToViewport();
          if (field && /^(INPUT|SELECT|TEXTAREA)$/.test(field.tagName)) {
            // scrollIntoView remonte naturellement le plus proche ancetre
            // scrollable (.zc-modal__sheet a overflow-y:auto), jamais le
            // document -- pas de plomberie supplementaire necessaire ici.
            field.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }, 300);
      });

      openModal = function () {
        lastFocused = document.activeElement;
        modal.hidden = false;
        document.body.classList.add("zc-modal-open");
        attachViewportListeners();
        requestAnimationFrame(function () {
          modal.classList.add("is-open");
          syncModalToViewport();
          var firstField = form.querySelector("input");
          if (firstField) firstField.focus();
          // Le focus programmatique declenche l'ouverture du clavier apres
          // coup sur certains navigateurs mobiles (le resize/scroll de
          // VisualViewport arrive avec un leger delai) -- plusieurs
          // recalages successifs couvrent l'ouverture progressive du
          // clavier sur les navigateurs les plus lents a la remonter.
          setTimeout(syncModalToViewport, 150);
          setTimeout(syncModalToViewport, 350);
          setTimeout(syncModalToViewport, 600);
        });
      };
      closeModal = function () {
        modal.classList.remove("is-open");
        document.body.classList.remove("zc-modal-open");
        modal.style.removeProperty("--cod-vvh");
        modal.style.transform = "";
        detachViewportListeners();
        setTimeout(function () {
          modal.hidden = true;
        }, 200);
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      };
      modalTrigger.addEventListener("click", openModal);
      if (modalBackdrop) modalBackdrop.addEventListener("click", closeModal);
      if (modalClose) modalClose.addEventListener("click", closeModal);
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
      });
    }

    // Bouton "Order Now" collant (mobile) : caché tant que le VRAI bouton
    // (bouton autonome en mode modal, sinon le panneau du formulaire inline)
    // est à l'écran -- jamais les deux visibles en même temps, sinon deux
    // "Order Now" se superposent. Dès qu'il sort de l'écran, la barre
    // collante prend le relais ; en mode modal, la cliquer ouvre directement
    // le popup (il n'y a plus de formulaire inline vers lequel scroller).
    //
    // NOTE : une variante de cette barre pilotee par VisualViewport pendant
    // la saisie (translateY au-dessus du clavier) a ete ecrite puis retiree
    // -- meme fondation que le fix modal deja invalide 2 fois en test
    // terrain sur FacebookApp WebView. Revert au comportement simple ici en
    // attendant la mesure ?coddebug=1 (voir project-cod-viewport-keyboard-fix).
    var stickyBar = root.querySelector("[data-zc-sticky]");
    var stickyBtn = root.querySelector("[data-zc-sticky-btn]");
    var formPanel = root.querySelector("[data-zc-panel]");
    var stickyWatchTarget = isModal ? modalTrigger : formPanel;
    if (stickyBar && stickyWatchTarget && "IntersectionObserver" in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var panelVisible = entries[0].isIntersecting;
          stickyBar.classList.toggle("is-visible", !panelVisible);
          stickyBar.hidden = panelVisible;
        },
        { rootMargin: "0px 0px -15% 0px" },
      );
      stickyObserver.observe(stickyWatchTarget);

      if (stickyBtn) {
        stickyBtn.addEventListener("click", function () {
          if (isModal) {
            openModal();
          } else {
            formPanel.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });
      }

      var stopSticky = function () {
        stickyObserver.disconnect();
        stickyBar.hidden = true;
        stickyBar.classList.remove("is-visible");
      };
      root.addEventListener("zc:order-confirmed", stopSticky);
    }

    function fieldError(name, message) {
      var input = form.elements[name];
      if (input) {
        input.setAttribute("aria-invalid", "true");
        // .closest() peut renvoyer null (ex. le champ honeypot "website" n'a
        // pas de wrapper .zc-field) -- causait le crash classList signale par
        // Clarity des qu'un rejet serveur nommait un champ sans ce wrapper.
        var wrapper = input.closest(".zc-field");
        if (wrapper) wrapper.classList.add("has-error");
        input.focus();
      }
      showError(message);
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearErrors() {
      if (errorBox) errorBox.hidden = true;
      Array.prototype.forEach.call(form.querySelectorAll("[aria-invalid]"), function (el) {
        el.removeAttribute("aria-invalid");
        // Meme garde que fieldError() : .closest() peut renvoyer null (champ
        // honeypot "website" sans wrapper .zc-field).
        var wrapper = el.closest(".zc-field");
        if (wrapper) wrapper.classList.remove("has-error");
      });
    }

    form.addEventListener("input", function (e) {
      var field = e.target.closest(".zc-field");
      if (field && field.classList.contains("has-error")) {
        field.classList.remove("has-error");
        e.target.removeAttribute("aria-invalid");
        if (errorBox) errorBox.hidden = true;
      }
    });

    // Filtrage en direct du champ téléphone : ne garde que des chiffres, et
    // si la cliente colle un numéro complet (avec 0/+260/260/espaces...),
    // le réduit silencieusement aux 9 chiffres nationaux au lieu de
    // laisser un format invalide visible dans le champ.
    var phoneInput = form.elements.phone;
    if (phoneInput) {
      phoneInput.addEventListener("input", function () {
        var extracted = extractNational(phoneInput.value).slice(0, 9);
        if (extracted !== phoneInput.value) {
          phoneInput.value = extracted;
        }
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearErrors();

      // Full name et ville : champs libres, jamais bloquants (même vides).
      var fullName = form.elements.fullName.value.trim();
      var phoneRaw = form.elements.phone.value;
      var city = form.elements.city.value.trim();

      var national = extractNational(phoneRaw);
      if (!isValidNational(national)) {
        return fieldError("phone", "Enter a valid Zambian number: 9 digits, starting with 9 or 7.");
      }
      var phone = "+260" + national;

      // Tâche 7 -- signaux d'attribution + marqueur de test. isTest ne
      // bloque jamais rien, il ne fait QUE marquer (utilisé côté serveur
      // pour: pas d'alerte email tâche 4, test_event_code CAPI tâche 8).
      var attr = readAttribution();
      var urlParams = new URLSearchParams(window.location.search);
      var isTest = TEST_NAME_RE.test(fullName) || urlParams.get("zan_test") === "1";
      var attribution = {
        fbp: getCookie("_fbp"),
        fbc: buildFbc(attr.fbclid),
        fbclid: attr.fbclid || null,
        utm_source: attr.utm_source || null,
        utm_medium: attr.utm_medium || null,
        utm_campaign: attr.utm_campaign || null,
        utm_content: attr.utm_content || null,
        utm_term: attr.utm_term || null,
        referrer: document.referrer || null,
        landing_url: window.location.href,
        event_source_url: window.location.href,
      };

      submit.disabled = true;
      var label = submit.querySelector("[data-zc-label]") || submit;
      // innerHTML et pas textContent : le libellé peut contenir le montant
      // ([data-zc-total]) qu'un textContent restauré aurait effacé.
      var original = label.innerHTML;
      var restoreLabel = function () {
        label.innerHTML = original;
        select(selected);
      };
      label.textContent = "Placing your order…";

      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          productId: productId,
          offerId: selected,
          fullName: fullName,
          phone: phone,
          city: city,
          address: form.elements.address ? form.elements.address.value.trim() : "",
          note: form.elements.note ? form.elements.note.value.trim() : "",
          website: form.elements.website ? form.elements.website.value : "",
          formOpenedAt: openedAt,
          attribution: attribution,
          isTest: isTest,
        }),
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { status: r.status, body: body };
          });
        })
        .then(function (res) {
          if (res.body && res.body.ok) return succeed(res.body);
          submit.disabled = false;
          restoreLabel();
          if (res.body && res.body.field) {
            fieldError(res.body.field, res.body.message);
          } else {
            showError((res.body && res.body.message) || "Something went wrong. Please try again.");
          }
        })
        .catch(function () {
          submit.disabled = false;
          restoreLabel();
          showError("Connection failed. Check your network and try again.");
        });
    });

    function succeed(data) {
      root.dispatchEvent(new Event("zc:order-confirmed"));

      // Signal analytics facultatif — ne bloque jamais la redirection/confirmation.
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "cod_order_placed",
          reference: data.reference,
          value: data.total,
          quantity: data.quantity,
        });
      } catch (err) {
        console.error("[zc] dataLayer push failed:", err);
      }

      // Tâche 3 -- l'événement Meta ne doit plus dépendre du fetch
      // /api/order-status (lui-même dépendant du store éphémère). eventId +
      // les données produit sont donc doublées ici : sessionStorage (survit
      // à la navigation same-origin) ET paramètres d'URL (filet de sécurité
      // si sessionStorage est indisponible -- navigation privée stricte...).
      // Jamais de fbq() ici : seul un window.Shopify.analytics.publish()
      // équivalent, câblé côté page de confirmation, doit exister.
      if (data.eventId) {
        try {
          sessionStorage.setItem(
            "zc_lead",
            JSON.stringify({
              eventId: data.eventId,
              orderNumber: data.orderNumber || data.reference,
              value: data.total,
              currency: data.currency || "ZMW",
              contentName: data.productName || "",
            }),
          );
        } catch (err) {
          console.error("[zc] sessionStorage write failed:", err);
        }
      }

      // Si une thank-you page Shopify est configurée, on y redirige avec un
      // token opaque -- jamais le montant/la commande en clair dans l'URL,
      // la page va les re-demander elle-même via GET /api/order-status/:token
      // pour l'AFFICHAGE uniquement (l'événement Meta, lui, ne dépend plus de
      // ce fetch -- voir zc_event/zc_value/zc_currency/zc_content ci-dessous).
      var thankYouUrl = root.dataset.thankyouUrl;
      if (thankYouUrl && data.token) {
        var qs = "token=" + encodeURIComponent(data.token);
        if (data.eventId) {
          qs += "&zc_event=" + encodeURIComponent(data.eventId);
          qs += "&zc_value=" + encodeURIComponent(data.total);
          qs += "&zc_currency=" + encodeURIComponent(data.currency || "ZMW");
          qs += "&zc_content=" + encodeURIComponent(data.productName || "");
        }
        window.location.href = thankYouUrl + (thankYouUrl.indexOf("?") === -1 ? "?" : "&") + qs;
        return;
      }

      var panel = root.querySelector("[data-zc-panel]");
      var done = root.querySelector("[data-zc-success]");
      if (!done) return;
      var ref = done.querySelector("[data-zc-ref]");
      var amount = done.querySelector("[data-zc-amount]");
      if (ref) ref.textContent = data.reference;
      if (amount) amount.textContent = data.totalLabel;
      if (panel) panel.hidden = true;
      done.hidden = false;
      done.setAttribute("tabindex", "-1");
      done.focus();
      done.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-zc]"), init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
